import { ISelectOption } from "components/common/CustomSelect";
import { ReactComponent as Transit1On } from 'assets/transport/detail/transit1On.svg';
import { ReactComponent as Transit2On } from 'assets/transport/detail/transit2On.svg';
import { ReactComponent as Transit3On } from 'assets/transport/detail/transit3On.svg';
import { ReactComponent as Transit4On } from 'assets/transport/detail/transit4On.svg';
import { ReactComponent as Transit5On } from 'assets/transport/detail/transit5On.svg';
import { ReactComponent as Transit6On } from 'assets/transport/detail/transit6On.svg';
import { ReactComponent as Transit7On } from 'assets/transport/detail/transit7On.svg';
import { ReactComponent as Transit8On } from 'assets/transport/detail/transit8On.svg';
import { ReactComponent as Transit9On } from 'assets/transport/detail/transit9On.svg';
import { ReactComponent as Transit10On } from 'assets/transport/detail/transit10On.svg';
import { ReactComponent as Transit11On } from 'assets/transport/detail/transit11On.svg';
import { ReactComponent as Transit1Off } from 'assets/transport/detail/transit1Off.svg';
import { ReactComponent as Transit2Off } from 'assets/transport/detail/transit2Off.svg';
import { ReactComponent as Transit3Off } from 'assets/transport/detail/transit3Off.svg';
import { ReactComponent as Transit4Off } from 'assets/transport/detail/transit4Off.svg';
import { ReactComponent as Transit5Off } from 'assets/transport/detail/transit5Off.svg';
import { ReactComponent as Transit6Off } from 'assets/transport/detail/transit6Off.svg';
import { ReactComponent as Transit7Off } from 'assets/transport/detail/transit7Off.svg';
import { ReactComponent as Transit8Off } from 'assets/transport/detail/transit8Off.svg';
import { ReactComponent as Transit9Off } from 'assets/transport/detail/transit9Off.svg';
import { ReactComponent as Transit10Off } from 'assets/transport/detail/transit10Off.svg';
import { ReactComponent as Transit11Off } from 'assets/transport/detail/transit11Off.svg';

const transportStatusSelect: ISelectOption[] = [
    { value: 'WAITING', label: '대기' },
    { value: 'PROGRESS', label: '진행중' },
    { value: 'PENDING', label: '보류' },
    { value: 'COMPLETE', label: '완료' },
    { value: 'CANCELED', label: '취소' },
]

const stepStatusSelect: ISelectOption[] = [
    { value: '0', label: '미진행' },
    { value: '1', label: '완료' },
]

const comPleteSelect: ISelectOption[] = [
    { value: '0', label: '미수' },
    { value: '1', label: '완료' },
]

const cargoOutStatusSelect: ISelectOption[] = [
    { value: '0', label: '출고일미정' },
    { value: '1', label: '출고일확정' },
]

const stepList = [
    { label: '화물출고', key: 'CARGO_OUT' },
    { label: '부킹', key: 'BOOKING' },
    { label: '수출통관', key: 'EXPORT_CUSTOMS' },
    { label: '서류마감', key: 'DOCUMENT_CUTOFF' },
    { label: '화물반입', key: 'CARGO_IN' },
    { label: '출항', key: 'DEPARTED' },
    { label: '운송중', key: 'IN_TRANSIT' },
    { label: '입항', key: 'ARRIVED' },
    { label: '운송완료', key: 'COMPLETE' },
]

const blStatusSelect: ISelectOption[] = [
    { value: '0', label: '미선택' },
    { value: '1', label: '오리지널BL' },
    { value: '2', label: '써렌더BL' },
    { value: '3', label: '씨웨이빌' },
]

const convertStatus = (status: string): string => {
    const find = transportStatusSelect.find(arr => arr.value === status)
    return find?.label || ''
}

interface IAirStatus {
    code: string,
    name: string,
    description: string,
    timing: string,
    IconOn: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    IconOff: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const airStatus: IAirStatus[] = [
    {
        code: "CPT",
        name: "서류수신",
        description: "서류(FWB 등) 수신됨",
        timing: "출발 전",
        IconOn: Transit5On,
        IconOff: Transit5Off
    },
    {
        code: "FOH",
        name: "화물인도",
        description: "포워더가 화물 인도",
        timing: "출발 전",
        IconOn: Transit8On,
        IconOff: Transit8Off
    },
    {
        code: "RCS",
        name: "적재준비",
        description: "항공사 수령 완료 및 적재 준비 완료",
        timing: "출발 전",
        IconOn: Transit9On,
        IconOff: Transit9Off
    },
    {
        code: "BKD",
        name: "항공예약",
        description: "항공편에 예약됨",
        timing: "출발 전",
        IconOn: Transit11On,
        IconOff: Transit11Off
    },
    {
        code: "MAN",
        name: "적하목록",
        description: "적하목록이 작성됨",
        timing: "출발 전",
        IconOn: Transit10On,
        IconOff: Transit10Off
    },
    {
        code: "DEP",
        name: "공항출발",
        description: "항공편이 출발함",
        timing: "출발 시각",
        IconOn: Transit7On,
        IconOff: Transit7Off
    },
    {
        code: "ARR",
        name: "공항도착",
        description: "공항에 도착",
        timing: "도착",
        IconOn: Transit6On,
        IconOff: Transit6Off
    },
    {
        code: "RCF",
        name: "물류입고",
        description: "항공기에서 내림, 창고 입고됨",
        timing: "도착 후",
        IconOn: Transit3On,
        IconOff: Transit3Off
    },
    {
        code: "NFD",
        name: "픽업안내",
        description: "고객에게 픽업 안내됨",
        timing: "도착 후",
        IconOn: Transit2On,
        IconOff: Transit2Off
    },
    {
        code: "AWD",
        name: "서류전달",
        description: "서류 전달됨",
        timing: "도착 후",
        IconOn: Transit4On,
        IconOff: Transit4Off
    },
    {
        code: "DLV",
        name: "배송완료",
        description: "최종 수령자에게 인도 완료",
        timing: "배송 완료 시점",
        IconOn: Transit1On,
        IconOff: Transit1Off
    }
];

export {
    stepStatusSelect,
    transportStatusSelect,
    comPleteSelect,
    stepList,
    cargoOutStatusSelect,
    convertStatus,
    airStatus,
    blStatusSelect
}